import type { SVGProps } from 'react';

const SvgSmsShortCode = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="smart-send-time">
      <path d="M3.48 26.78h11.3l8.6 5a.69.69 0 0 0 .37.1.74.74 0 0 0 .75-.75v-4.35h4A2.75 2.75 0 0 0 31.27 24V2.84A2.75 2.75 0 0 0 28.52.09h-25A2.75 2.75 0 0 0 .73 2.84V24a2.75 2.75 0 0 0 2.75 2.78ZM2.23 2.84a1.25 1.25 0 0 1 1.25-1.25h25a1.25 1.25 0 0 1 1.25 1.25V24a1.25 1.25 0 0 1-1.25 1.25h-4.73A.76.76 0 0 0 23 26v3.82l-7.64-4.47a.86.86 0 0 0-.38-.1H3.48A1.25 1.25 0 0 1 2.23 24Z" />
      <path d="m9.88 17.64 1.06-1.06-3.86-3.87 3.86-3.86-1.06-1.06-4.4 4.39a.75.75 0 0 0 0 1.06ZM22.24 17.64l4.4-4.4a.75.75 0 0 0 0-1.06l-4.4-4.39-1.06 1.06 3.87 3.86-3.87 3.87ZM13.695 19.891l3.256-14.345 1.463.332-3.256 14.345z" />
    </g>
  </svg>
);

export default SvgSmsShortCode;
